export default "__VITE_PUBLIC_ASSET__2a18951a__"